import { useParams } from "react-router";
import { Button } from "@astryxdesign/core/Button";
import { EmptyState } from "@astryxdesign/core/EmptyState";
import { Center } from "@astryxdesign/core/Center";
import { StudioThemed } from "@/features/studio/StudioRoot";
import { LOADING_ACCENT } from "@/theme/studio-theme";
import { useT } from "@/lib/i18n";

export function NotFound({ inStudio = false }: { inStudio?: boolean }) {
  const { slug } = useParams();
  const t = useT();
  const body = (
    <Center height="80dvh">
      <EmptyState
        title={inStudio ? t.notFound.pageTitle : t.notFound.linkTitle}
        description={inStudio ? t.notFound.pageText : t.notFound.linkText}
        actions={inStudio && slug ? <Button label={t.notFound.toHome} variant="primary" href={`/s/${slug}`} /> : undefined}
      />
    </Center>
  );
  return inStudio ? body : <StudioThemed accent={LOADING_ACCENT}>{body}</StudioThemed>;
}
